import { ANCHOR_REGEX } from '@monoimin/constants';

export const replaceAnchorsFromString = (string: string) => {
  return string.replace(ANCHOR_REGEX, '');
};

export default replaceAnchorsFromString;
